module.exports = "<div class=\"alert alert-success text-center\">\n  Controller has been successfully created\n</div>\n\n<div style=\"margin-bottom: 1rem;\">\n  <p>Click the following <a [href]=data.link target=\"_blank\">link</a> to download your files</p>\n  <p>Please note, that the link is valid only for 10 minutes</p>\n</div>\n\n<div>\n  <button mat-raised-button type=\"button\" (click)=\"onCloseCancel()\">Close</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/controller/controller-dialog.html
// module id = ./src/app/controller/controller-dialog.html
// module chunks = main